var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 842,
    height: 625,
    viewBox: "0 0 842 625",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0144928,
    d: "M187.362 530.288C177.386 532.562 167.129 528.041 162.161 519.182L98.4357 405.555C95.4724 400.271 94.7397 394.025 96.3979 388.182L150.639 197.055C151.947 192.446 154.67 188.351 158.426 185.344L291.932 78.4671C298.683 73.0629 307.887 71.851 315.775 75.3276L417.812 120.295C425.701 123.771 430.949 131.353 431.409 139.935L440.501 309.654C440.756 314.429 439.504 319.171 436.919 323.218L329.718 491.006C326.441 496.135 321.261 499.776 315.312 501.132L187.362 530.288Z",
    stroke: "url(#paint0_linear_6_177)",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0289855,
    d: "M209.652 535.098C199.839 537.86 189.4 533.894 183.975 525.342L114.692 416.134C111.44 411.008 110.37 404.796 111.717 398.862L155.252 207.075C156.316 202.385 158.831 198.138 162.442 194.932L289.08 82.512C295.534 76.782 304.645 75.1028 312.69 78.1599L416.296 117.526C424.342 120.583 429.977 127.865 430.9 136.398L449.013 303.818C449.53 308.591 448.528 313.413 446.148 317.604L348.851 488.963C345.841 494.265 340.846 498.173 334.964 499.828L209.652 535.098Z",
    stroke: "url(#paint1_linear_6_177)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0434783,
    d: "M231.928 539.206C222.302 542.446 211.712 539.04 205.848 530.818L131.3 426.292C127.767 421.339 126.361 415.18 127.392 409.171L160.301 217.304C161.117 212.545 163.415 208.156 166.869 204.76L286.422 87.2106C292.565 81.1709 301.557 79.0309 309.738 81.662L414.6 115.387C422.781 118.018 428.785 124.981 430.168 133.441L457.085 298.098C457.862 302.855 457.115 307.742 454.95 312.067L367.638 486.437C364.903 491.898 360.109 496.063 354.309 498.015L231.928 539.206Z",
    stroke: "url(#paint2_linear_6_177)",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.057971,
    d: "M254.153 542.619C244.737 546.326 234.024 543.485 227.742 535.614L148.234 436.015C144.429 431.249 142.69 425.161 143.4 419.095L165.795 227.715C166.359 222.902 168.432 218.383 171.719 214.804L283.995 92.5462C289.81 86.2137 298.662 83.6207 306.955 85.8202L412.761 113.882C421.054 116.082 427.41 122.708 429.248 131.071L464.724 292.516C465.763 297.242 465.276 302.182 463.332 306.629L386.054 483.452C383.604 489.057 379.022 493.469 373.321 495.713L254.153 542.619Z",
    stroke: "url(#paint3_linear_6_177)",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0724638,
    d: "M276.288 545.347C267.103 549.508 256.298 547.235 249.617 539.736L165.465 445.289C161.4 440.726 159.331 434.727 159.717 428.619L171.741 238.285C172.048 233.431 173.889 228.793 176.999 225.039L281.83 98.5005C287.304 91.8926 295.992 88.8555 304.375 90.6192L410.813 113.013C419.196 114.777 425.885 121.049 428.171 129.29L471.942 287.093C473.24 291.775 473.016 296.753 471.302 301.311L404.075 480.031C401.918 485.765 397.563 490.413 391.974 492.945L276.288 545.347Z",
    stroke: "url(#paint4_linear_6_177)",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0869565,
    d: "M298.295 547.402C289.364 552.002 278.496 550.299 271.438 543.191L182.969 454.102C178.654 449.756 176.26 443.863 176.319 437.733L178.146 248.987C178.193 244.105 179.795 239.361 182.718 235.44L279.961 105.053C285.081 98.1883 293.583 94.7171 302.033 96.0418L408.794 112.779C417.244 114.104 424.246 120.006 426.973 128.101L478.75 281.85C480.307 286.473 480.349 291.475 478.87 296.132L421.681 476.199C419.824 482.048 415.708 486.92 410.247 489.733L298.295 547.402Z",
    stroke: "url(#paint5_linear_6_177)",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.101449,
    d: "M320.139 548.796C311.482 553.822 300.58 552.688 293.168 545.99L200.718 462.444C196.164 458.329 193.451 452.561 193.182 446.426L185.012 259.795C184.798 254.9 186.154 250.062 188.882 245.985L278.419 112.184C283.173 105.08 291.467 101.186 299.961 102.069L406.739 113.178C415.233 114.062 422.528 119.578 425.686 127.504L485.162 276.808C486.974 281.358 487.284 286.369 486.046 291.113L438.853 471.984C437.301 477.93 433.436 483.014 428.117 486.102L320.139 548.796Z",
    stroke: "url(#paint6_linear_6_177)",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.115942,
    d: "M341.784 549.544C333.422 554.98 322.514 554.415 314.771 548.143L218.683 470.308C213.904 466.437 210.878 460.811 210.281 454.687L192.343 270.684C191.866 265.79 192.971 260.871 195.495 256.647L277.233 119.867C281.609 112.545 289.676 108.239 298.191 108.681L404.682 114.205C413.198 114.647 420.765 119.763 424.344 127.499L491.19 271.986C493.254 276.448 493.833 281.454 492.842 286.272L455.571 467.411C454.331 473.44 450.727 478.722 445.565 482.078L341.784 549.544Z",
    stroke: "url(#paint7_linear_6_177)",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.130435,
    d: "M363.197 549.664C355.148 555.494 344.263 555.494 336.214 549.664L236.839 477.686C231.847 474.071 228.515 468.604 227.591 462.51L200.141 281.628C199.4 276.749 200.249 271.762 202.56 267.402L276.432 128.08C280.421 120.558 288.238 115.855 296.753 115.855H402.658C411.173 115.855 418.99 120.558 422.979 128.08L496.851 267.402C499.163 271.762 500.011 276.749 499.27 281.628L471.821 462.51C470.896 468.604 467.564 474.071 462.573 477.686L363.197 549.664Z",
    stroke: "url(#paint8_linear_6_177)",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.144928,
    d: "M384.344 549.174C376.625 555.381 365.793 555.943 357.462 550.569L255.154 484.574C249.964 481.226 246.336 475.934 245.085 469.888L208.403 292.6C207.4 287.751 207.988 282.71 210.079 278.225L276.042 136.796C279.633 129.095 287.183 124.007 295.673 123.567L400.701 118.119C409.191 117.678 417.237 121.957 421.623 129.244L502.159 263.074C504.713 267.318 505.83 272.271 505.344 277.197L487.585 457.308C486.979 463.45 483.93 469.089 479.122 472.955L384.344 549.174Z",
    stroke: "url(#paint9_linear_6_177)",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15942,
    d: "M405.193 548.095C397.823 554.661 387.072 555.78 378.484 550.874L273.604 490.966C268.23 487.896 264.314 482.796 262.74 476.816L217.129 303.577C215.864 298.772 216.189 293.69 218.054 289.092L276.086 145.988C279.274 138.128 286.537 132.671 294.98 131.793L398.845 120.987C407.288 120.109 415.539 123.952 420.307 130.984L507.131 259.018C509.921 263.132 511.306 268.036 511.077 272.996L502.852 451.836C502.568 458.01 499.809 463.804 495.198 467.912L405.193 548.095Z",
    stroke: "url(#paint10_linear_6_177)",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.173913,
    d: "M425.715 546.449C418.71 553.355 408.067 555.023 399.249 550.599L292.158 496.861C286.616 494.08 282.424 489.187 280.529 483.29L226.316 314.532C224.792 309.785 224.85 304.677 226.482 299.976L276.589 155.627C279.365 147.629 286.324 141.819 294.699 140.506L397.12 124.449C405.494 123.136 413.927 126.534 419.064 133.29L511.784 255.249C514.804 259.22 516.453 264.061 516.485 269.041L517.611 446.122C517.65 452.31 515.19 458.246 510.788 462.586L425.715 546.449Z",
    stroke: "url(#paint11_linear_6_177)",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.188406,
    d: "M445.881 544.26C439.256 551.486 428.749 553.697 419.727 549.763L310.791 502.259C305.095 499.776 300.637 495.105 298.427 489.308L235.96 325.441C234.178 320.767 233.968 315.647 235.361 310.855L277.571 165.683C279.931 157.569 286.568 151.422 294.851 149.679L395.559 128.491C403.842 126.748 412.432 129.692 417.921 136.154L516.136 251.782C519.378 255.598 521.29 260.36 521.582 265.347L531.852 440.197C532.215 446.383 530.061 452.444 525.879 457.006L445.881 544.26Z",
    stroke: "url(#paint12_linear_6_177)",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.202899,
    d: "M465.664 541.552C459.433 549.079 449.088 551.822 439.89 548.388L329.473 507.16C323.641 504.982 318.929 500.549 316.409 494.869L246.054 336.279C244.019 331.691 243.54 326.573 244.689 321.703L279.052 176.127C280.99 167.918 287.29 161.451 295.46 159.284L394.192 133.098C402.362 130.931 411.085 133.414 416.91 139.563L520.206 248.63C523.661 252.278 525.831 256.948 526.386 261.928L545.567 434.091C546.254 440.258 544.413 446.429 540.462 451.2L465.664 541.552Z",
    stroke: "url(#paint13_linear_6_177)",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.217391,
    d: "M485.038 538.352C479.214 546.158 469.06 549.424 459.712 546.497L348.177 511.566C342.226 509.702 337.274 505.52 334.45 499.973L256.591 347.022C254.307 342.535 253.559 337.433 254.46 332.497L281.049 186.926C282.561 178.644 288.509 171.875 296.544 169.291L393.049 138.253C401.084 135.669 409.915 137.685 416.057 143.505L524.012 245.806C527.672 249.274 530.096 253.837 530.913 258.796L558.75 427.835C559.76 433.966 558.237 440.23 554.529 445.201L485.038 538.352Z",
    stroke: "url(#paint14_linear_6_177)",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.231884,
    d: "M503.98 534.687C498.576 542.752 488.637 546.528 479.169 544.114L366.878 515.482C360.824 513.938 355.645 510.02 352.525 504.623L267.564 357.647C265.036 353.274 264.019 348.203 264.668 343.214L283.576 198.049C284.662 189.715 290.243 182.663 298.122 179.67L392.157 143.94C400.036 140.946 408.95 142.491 415.391 147.965L527.575 243.32C531.43 246.597 534.103 251.04 535.18 255.964L571.398 421.46C572.728 427.537 571.528 433.879 568.073 439.036L503.98 534.687Z",
    stroke: "url(#paint15_linear_6_177)",
    strokeWidth: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.246377,
    d: "M522.468 530.586C517.495 538.888 507.797 543.162 498.236 541.265L385.548 518.912C379.409 517.694 374.018 514.052 370.61 508.821L278.961 368.131C276.196 363.886 274.911 358.859 275.306 353.83L286.649 209.463C287.306 201.099 292.507 193.784 300.209 190.39L391.543 150.139C399.245 146.744 408.218 147.814 414.937 152.927L530.914 241.183C534.955 244.258 537.869 248.567 539.206 253.442L583.508 414.996C585.155 421.004 584.282 427.406 581.089 432.737L522.468 530.586Z",
    stroke: "url(#paint16_linear_6_177)",
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26087,
    d: "M540.482 526.079C535.949 534.595 526.517 539.352 516.892 537.976L404.161 521.863C397.955 520.975 392.366 517.621 388.68 512.571L290.773 378.453C287.776 374.348 286.226 369.379 286.364 364.322L290.277 221.136C290.506 212.764 295.314 205.204 302.819 201.419L391.233 156.828C398.737 153.044 407.742 153.636 414.719 158.374L534.05 239.404C538.264 242.266 541.414 246.427 543.008 251.24L595.079 408.475C597.04 414.396 596.497 420.843 593.574 426.334L540.482 526.079Z",
    stroke: "url(#paint17_linear_6_177)",
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.275362,
    d: "M558.004 521.195C553.921 529.903 544.778 535.128 535.118 534.274L422.693 524.342C416.437 523.79 410.667 520.734 406.711 515.879L302.988 388.59C299.767 384.637 297.954 379.741 297.834 374.67L294.471 233.032C294.272 224.673 298.677 216.891 305.964 212.727L391.251 163.987C398.537 159.823 407.549 159.938 414.763 164.288L537.004 237.99C541.381 240.629 544.758 244.631 546.606 249.368L606.113 401.926C608.383 407.744 608.171 414.218 605.527 419.857L558.004 521.195Z",
    stroke: "url(#paint18_linear_6_177)",
    strokeWidth: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.289855,
    d: "M575.017 515.968C571.391 524.844 562.562 530.519 552.895 530.188L441.118 526.36C434.831 526.145 428.896 523.398 424.682 518.753L315.592 398.523C312.155 394.735 310.083 389.925 309.703 384.851L299.237 245.12C298.614 236.796 302.605 228.811 309.655 224.28L391.619 171.593C398.668 167.062 407.661 166.7 415.09 170.65L539.796 236.947C544.324 239.354 547.92 243.184 550.019 247.833L616.613 395.38C619.185 401.079 619.306 407.564 616.948 413.336L575.017 515.968Z",
    stroke: "url(#paint19_linear_6_177)",
    strokeWidth: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.304348,
    d: "M591.508 510.427C588.345 519.448 579.853 525.556 570.207 525.746L459.412 527.926C453.114 528.05 447.03 525.62 442.569 521.199L328.571 408.231C324.927 404.619 322.6 399.908 321.96 394.846L304.582 257.364C303.537 249.096 307.105 240.931 313.899 236.045L392.358 179.621C399.152 174.735 408.1 173.899 415.722 177.438L542.448 236.282C547.114 238.449 550.921 242.095 553.266 246.642L626.582 388.866C629.451 394.431 629.906 400.91 627.841 406.801L591.508 510.427Z",
    stroke: "url(#paint20_linear_6_177)",
    strokeWidth: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.318841,
    d: "M607.464 504.607C604.77 513.749 596.635 520.27 587.04 520.977L477.553 529.052C471.261 529.516 465.046 527.412 460.35 523.228L341.911 417.696C338.068 414.271 335.491 409.673 334.591 404.635L310.508 269.731C309.045 261.54 312.183 253.217 318.703 247.991L393.489 188.047C400.009 182.82 408.886 181.513 416.677 184.632L544.981 235.998C549.773 237.916 553.781 241.367 556.366 245.8L636.028 382.413C639.187 387.83 639.974 394.285 638.207 400.281L607.464 504.607Z",
    stroke: "url(#paint21_linear_6_177)",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333333,
    d: "M622.875 498.539C620.654 507.778 612.896 514.692 603.382 515.912L495.519 529.751C489.252 530.555 482.923 528.783 478.005 524.848L355.595 426.899C351.563 423.673 348.741 419.2 347.583 414.199L317.017 282.188C315.143 274.094 317.843 265.635 324.072 260.084L395.028 196.844C401.257 191.292 410.039 189.519 417.975 192.21L547.417 236.098C552.321 237.761 556.52 241.006 559.34 245.313L644.958 376.052C648.398 381.304 649.517 387.72 648.054 393.806L622.875 498.539Z",
    stroke: "url(#paint22_linear_6_177)",
    strokeWidth: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.347826,
    d: "M637.732 492.258C635.987 501.569 628.627 508.854 619.22 510.581L513.288 530.037C507.064 531.18 500.639 529.747 495.512 526.072L369.606 435.825C365.395 432.807 362.335 428.472 360.92 423.52L324.108 294.699C321.829 286.724 324.085 278.152 330.006 272.291L396.993 205.986C402.914 200.125 411.574 197.892 419.631 200.148L549.776 236.585C554.779 237.986 559.158 241.015 562.208 245.183L653.382 369.808C657.094 374.883 658.542 381.243 657.387 387.403L637.732 492.258Z",
    stroke: "url(#paint23_linear_6_177)",
    strokeWidth: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.362319,
    d: "M652.03 485.795C650.762 495.154 643.818 502.787 634.547 505.014L530.84 529.924C524.678 531.404 518.175 530.314 512.853 526.911L383.926 444.457C379.547 441.657 376.255 437.471 374.585 432.582L331.779 307.233C329.103 299.396 330.911 290.734 336.508 284.581L399.398 215.446C404.995 209.293 413.508 206.607 421.663 208.423L552.08 237.459C557.168 238.592 561.717 241.395 564.989 245.413L661.31 363.711C665.286 368.594 667.06 374.881 666.217 381.101L652.03 485.795Z",
    stroke: "url(#paint24_linear_6_177)",
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.376812,
    d: "M665.765 479.186C664.974 488.568 658.463 496.526 649.356 499.242L548.155 529.428C542.074 531.242 535.513 530.501 530.01 527.379L398.538 452.781C394.002 450.207 390.485 446.183 388.563 441.368L340.026 319.756C336.961 312.076 338.318 303.348 343.576 296.921L402.255 225.196C407.513 218.768 415.856 215.64 424.083 217.011L554.351 238.72C559.509 239.579 564.217 242.148 567.704 246.004L668.756 357.785C672.985 362.464 675.082 368.663 674.553 374.927L665.765 479.186Z",
    stroke: "url(#paint25_linear_6_177)",
    strokeWidth: 4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.391304,
    d: "M678.932 472.462C678.618 481.843 672.556 490.101 663.64 493.296L565.216 528.567C559.233 530.71 552.631 530.321 546.963 527.489L413.421 460.782C408.739 458.444 405.005 454.593 402.835 449.863L348.841 332.236C345.397 324.733 346.3 315.962 351.206 309.278L405.575 235.207C410.481 228.524 418.629 224.962 426.903 225.886L556.608 240.366C561.823 240.948 566.677 243.273 570.371 246.958L675.732 352.058C680.204 356.519 682.618 362.614 682.407 368.908L678.932 472.462Z",
    stroke: "url(#paint26_linear_6_177)",
    strokeWidth: 4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.405797,
    d: "M691.535 465.657C691.694 475.012 686.096 483.544 677.397 487.206L582.005 527.357C576.139 529.825 569.516 529.789 563.697 527.257L428.556 468.449C423.74 466.353 419.798 462.686 417.382 458.055L358.217 344.641C354.405 337.333 354.854 328.542 359.394 321.622L409.369 245.451C413.909 238.531 421.839 234.549 430.135 235.024L558.873 242.395C564.129 242.696 569.118 244.769 573.011 248.272L682.254 346.554C686.957 350.785 689.685 356.76 689.792 363.068L691.535 465.657Z",
    stroke: "url(#paint27_linear_6_177)",
    strokeWidth: 4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42029,
    d: "M703.573 458.805C704.202 468.11 699.081 476.889 690.625 481.002L598.506 525.816C592.776 528.604 586.15 528.923 580.196 526.698L443.923 475.769C438.985 473.924 434.842 470.451 432.186 465.93L368.144 356.941C363.975 349.845 363.97 341.059 368.133 333.922L413.642 255.899C417.805 248.763 425.495 244.374 433.787 244.4L561.166 244.803C566.45 244.82 571.56 246.634 575.643 249.944L688.339 341.295C693.262 345.286 696.296 351.126 696.722 357.432L703.573 458.805Z",
    stroke: "url(#paint28_linear_6_177)",
    strokeWidth: 4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.434783,
    d: "M715.05 451.936C716.144 461.167 711.511 470.166 703.324 474.716L614.705 523.965C609.127 527.065 602.517 527.74 596.445 525.829L459.5 482.733C454.453 481.145 450.119 477.876 447.227 473.477L378.61 369.104C374.096 362.238 373.64 353.48 377.414 346.148L418.402 266.523C422.176 259.191 429.603 254.408 437.868 253.987L563.507 247.586C568.803 247.316 574.022 248.865 578.287 251.973L694.005 336.306C699.135 340.045 702.469 345.735 703.214 352.023L715.05 451.936Z",
    stroke: "url(#paint29_linear_6_177)",
    strokeWidth: 4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.449275,
    d: "M725.973 445.084C727.524 454.216 723.39 463.408 715.495 468.377L630.588 521.822C625.18 525.227 618.606 526.256 612.431 524.666L475.267 489.332C470.123 488.007 465.607 484.952 462.485 480.685L389.602 381.102C384.758 374.483 383.852 365.776 387.229 358.27L423.653 277.292C427.029 269.786 434.172 264.626 442.383 263.76L565.916 250.737C571.209 250.179 576.524 251.457 580.961 254.354L699.27 331.607C704.595 335.085 708.221 340.609 709.284 346.865L725.973 445.084Z",
    stroke: "url(#paint30_linear_6_177)",
    strokeWidth: 4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.463768,
    d: "M736.348 438.279C738.35 447.29 734.722 456.644 727.143 462.015L646.142 519.408C640.921 523.108 634.401 524.491 628.141 523.226L491.201 495.557C485.974 494.501 481.286 491.669 477.938 487.546L401.105 392.907C395.944 386.549 394.594 377.917 397.564 370.259L429.395 288.178C432.365 280.521 439.204 275 447.337 273.694L568.412 254.251C573.687 253.404 579.085 254.405 583.684 257.082L704.155 327.219C709.662 330.425 713.572 335.771 714.951 341.978L736.348 438.279Z",
    stroke: "url(#paint31_linear_6_177)",
    strokeWidth: 4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.478261,
    d: "M746.184 431.551C748.627 440.417 745.513 449.906 738.271 455.658L661.357 516.743C656.339 520.729 649.893 522.462 643.564 521.528L507.28 501.402C501.983 500.62 497.133 498.02 493.567 494.051L413.102 404.491C407.639 398.41 405.85 389.876 408.406 382.089L435.631 299.153C438.187 291.365 444.702 285.502 452.733 283.761L571.013 258.12C576.256 256.984 581.723 257.702 586.473 260.151L708.68 323.16C714.355 326.086 718.541 331.239 720.234 337.383L746.184 431.551Z",
    stroke: "url(#paint32_linear_6_177)",
    strokeWidth: 4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.492754,
    d: "M755.493 424.931C758.367 433.63 755.77 443.224 748.887 449.335L676.223 513.849C671.424 518.11 665.07 520.191 658.69 519.59L523.483 506.863C518.128 506.359 513.128 503.999 509.35 500.194L425.576 415.829C419.827 410.039 417.606 401.626 419.743 393.732L442.359 310.187C444.495 302.293 450.669 296.106 458.573 293.937L573.739 262.335C578.933 260.91 584.455 261.342 589.347 263.555L712.869 319.448C718.697 322.086 723.149 327.032 725.153 333.098L755.493 424.931Z",
    stroke: "url(#paint33_linear_6_177)",
    strokeWidth: 4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.507246,
    d: "M764.287 418.446C767.581 426.957 765.504 436.625 758.999 443.074L690.731 510.746C686.166 515.271 679.923 517.694 673.509 517.431L539.786 511.933C534.388 511.711 529.248 509.6 525.265 505.97L438.507 426.896C432.488 421.41 429.843 413.14 431.556 405.162L449.575 321.252C451.288 313.275 457.103 306.785 464.856 304.196L576.606 266.887C581.736 265.174 587.3 265.315 592.322 267.286L716.743 316.1C722.711 318.442 727.419 323.169 729.73 329.141L764.287 418.446Z",
    stroke: "url(#paint34_linear_6_177)",
    strokeWidth: 4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.521739,
    d: "M772.58 412.125C776.28 420.426 774.726 430.14 768.616 436.903L704.875 507.456C700.559 512.233 694.445 514.994 688.013 515.069L556.168 516.612C550.74 516.676 545.471 514.821 541.29 511.375L451.875 437.668C445.603 432.498 442.543 424.394 443.829 416.356L457.276 332.322C458.562 324.285 464.002 317.513 471.581 314.514L579.631 271.765C584.682 269.766 590.273 269.614 595.415 271.334L720.326 313.13C726.419 315.169 731.372 319.664 733.985 325.527L772.58 412.125Z",
    stroke: "url(#paint35_linear_6_177)",
    strokeWidth: 4
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.536232,
    d: "M780.388 405.993C784.48 414.064 783.447 423.794 777.749 430.846L718.647 504.002C714.595 509.018 708.628 512.109 702.198 512.525L572.605 520.897C567.162 521.249 561.775 519.656 557.405 516.404L465.658 448.125C459.151 443.282 455.687 435.364 456.544 427.29L465.456 343.369C466.313 335.295 471.364 328.263 478.746 324.865L582.831 276.959C587.788 274.677 593.392 274.228 598.642 275.692L723.644 310.551C729.847 312.281 735.034 316.533 737.944 322.273L780.388 405.993Z",
    stroke: "url(#paint36_linear_6_177)",
    strokeWidth: 4
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.550725,
    d: "M787.727 400.077C792.196 407.898 791.682 417.614 786.412 424.93L732.044 500.404C728.269 505.645 722.467 509.06 716.055 509.816L589.074 524.788C583.63 525.43 578.138 524.107 573.587 521.058L479.832 458.244C473.108 453.739 469.252 446.028 469.681 437.942L474.106 354.366C474.534 346.28 479.183 339.01 486.345 335.225L586.22 282.456C591.068 279.894 596.67 279.147 602.016 280.348L726.72 308.376C733.017 309.792 738.427 313.789 741.628 319.391L787.727 400.077Z",
    stroke: "url(#paint37_linear_6_177)",
    strokeWidth: 4
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.565217,
    d: "M794.617 394.4C799.446 401.953 799.446 411.625 794.617 419.179L745.062 496.685C741.577 502.136 735.957 505.867 729.581 506.963L605.554 528.286C600.123 529.219 594.538 528.172 589.814 525.335L494.375 468.007C487.453 463.849 483.218 456.366 483.218 448.291V365.288C483.218 357.213 487.453 349.729 494.375 345.571L589.814 288.244C594.538 285.406 600.123 284.359 605.554 285.293L729.581 306.615C735.958 307.711 741.577 311.442 745.062 316.893L794.617 394.4Z",
    stroke: "url(#paint38_linear_6_177)",
    strokeWidth: 4
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57971,
    d: "M801.075 388.984C806.248 396.253 806.757 405.852 802.379 413.616L757.699 492.867C754.516 498.513 749.096 502.551 742.774 503.986L622.022 531.392C616.619 532.619 610.953 531.853 606.065 529.236L509.261 477.398C502.159 473.595 497.56 466.358 497.134 458.317L492.781 376.11C492.356 368.069 496.166 360.396 502.827 355.879L593.627 294.309C598.211 291.201 603.765 289.853 609.268 290.513L732.253 305.276C738.692 306.049 744.509 309.504 748.271 314.79L801.075 388.984Z",
    stroke: "url(#paint39_linear_6_177)",
    strokeWidth: 4
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.594203,
    d: "M807.124 383.852C812.622 390.819 813.631 400.317 809.716 408.263L769.955 488.971C767.085 494.796 761.881 499.13 755.63 500.902L638.456 534.111C633.095 535.631 627.361 535.151 622.32 532.763L524.464 486.399C517.203 482.959 512.254 475.987 511.406 468.004L502.784 386.808C501.937 378.825 505.313 370.987 511.693 366.127L597.672 300.639C602.101 297.264 607.61 295.616 613.172 295.998L734.761 304.368C741.248 304.814 747.248 307.983 751.279 313.09L807.124 383.852Z",
    stroke: "url(#paint40_linear_6_177)",
    strokeWidth: 4
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.608696,
    d: "M812.784 379.022C818.589 385.673 820.088 395.042 816.644 403.143L781.829 485.02C779.283 491.007 774.312 495.627 768.15 497.732L654.834 536.447C649.531 538.259 643.742 538.071 638.556 535.919L539.959 494.997C532.558 491.925 527.275 485.235 526.011 477.334L513.214 397.359C511.949 389.457 514.885 381.479 520.965 376.294L601.961 307.217C606.221 303.583 611.668 301.634 617.277 301.735L737.134 303.895C743.651 304.012 749.822 306.886 754.112 311.801L812.784 379.022Z",
    stroke: "url(#paint41_linear_6_177)",
    strokeWidth: 4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.623188,
    d: "M818.078 374.513C824.17 380.834 826.149 390.047 823.181 398.274L793.324 481.033C791.111 487.165 786.388 492.06 780.333 494.494L671.135 538.406C665.904 540.509 660.074 540.617 654.753 538.708L555.719 503.179C548.197 500.481 542.598 494.09 540.923 486.292L524.055 407.742C522.381 399.943 524.87 391.851 530.632 386.358L606.505 314.029C610.581 310.143 615.952 307.894 621.595 307.71L739.396 303.862C745.929 303.649 752.254 306.218 756.795 310.929L818.078 374.513Z",
    stroke: "url(#paint42_linear_6_177)",
    strokeWidth: 4
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.637681,
    d: "M823.031 370.343C829.389 376.32 831.834 385.352 829.347 393.676L804.441 477.033C802.571 483.292 798.112 488.448 792.181 491.208L687.338 539.994C682.194 542.387 676.336 542.794 670.891 541.136L571.715 510.935C564.093 508.614 558.196 502.537 556.119 494.864L535.294 417.935C533.217 410.262 535.254 402.081 540.683 396.299L611.316 321.06C615.193 316.929 620.472 314.382 626.136 313.909L741.576 304.271C748.107 303.726 754.573 305.984 759.355 310.479L823.031 370.343Z",
    stroke: "url(#paint43_linear_6_177)",
    strokeWidth: 4
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.652174,
    d: "M827.664 366.526C834.268 372.149 837.165 380.974 835.162 389.365L815.186 473.04C813.666 479.408 809.485 484.812 803.695 487.891L703.422 541.22C698.38 543.901 692.508 544.61 686.95 543.21L587.92 518.255C580.219 516.314 574.042 510.566 571.572 503.04L546.913 427.919C544.442 420.393 546.026 412.149 551.104 406.098L616.402 328.293C620.067 323.926 625.239 321.084 630.91 320.32L743.701 305.124C750.213 304.247 756.805 306.186 761.816 310.453L827.664 366.526Z",
    stroke: "url(#paint44_linear_6_177)",
    strokeWidth: 4
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.666667,
    d: "M832.005 363.075C838.833 368.334 842.166 376.929 840.647 385.359L825.564 469.074C824.401 475.531 820.512 481.169 814.881 484.561L719.368 542.092C714.444 545.058 708.572 546.073 702.912 544.936L604.307 525.132C596.546 523.573 590.109 518.166 587.256 510.808L558.895 437.676C556.041 430.318 557.169 422.037 561.883 415.738L621.772 335.712C625.21 331.118 630.26 327.983 635.925 326.926L745.796 306.42C752.273 305.211 758.975 306.825 764.205 310.853L832.005 363.075Z",
    stroke: "url(#paint45_linear_6_177)",
    strokeWidth: 4
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.681159,
    d: "M836.077 360.004C843.107 364.89 846.859 373.231 845.823 381.672L835.58 465.154C834.779 471.682 831.195 477.539 825.74 481.236L735.156 542.622C730.364 545.869 724.507 547.191 718.755 546.324L620.846 531.559C613.045 530.383 606.369 525.329 603.144 518.159L571.22 447.188C567.995 440.018 568.668 431.725 573.005 425.2L627.434 343.3C630.631 338.489 635.543 335.065 641.188 333.713L747.888 308.156C754.314 306.617 761.109 307.9 766.546 311.679L836.077 360.004Z",
    stroke: "url(#paint46_linear_6_177)",
    strokeWidth: 4
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.695652,
    d: "M839.907 357.323C847.118 361.829 851.27 369.895 850.714 378.318L845.242 461.3C844.809 467.878 841.543 473.939 836.28 477.932L750.767 542.82C746.123 546.343 740.295 547.975 734.465 547.382L637.509 537.534C629.689 536.74 622.794 532.05 619.21 525.087L583.872 456.439C580.288 449.477 580.508 441.198 584.455 434.469L633.395 351.04C636.338 346.023 641.097 342.315 646.707 340.667L750.004 310.33C756.362 308.462 763.235 309.409 768.866 312.929L839.907 357.323Z",
    stroke: "url(#paint47_linear_6_177)",
    strokeWidth: 4
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.710145,
    d: "M843.521 355.04C850.889 359.159 855.423 366.931 855.343 375.307L854.559 457.53C854.496 464.139 851.56 470.386 846.506 474.667L766.184 542.698C761.703 546.493 755.92 548.435 750.023 548.122L654.268 543.054C646.449 542.64 639.356 538.323 635.427 531.587L596.83 465.415C592.901 458.679 592.67 450.44 596.218 443.531L639.66 358.914C642.336 353.703 646.926 349.716 652.487 347.772L752.17 312.935C758.443 310.743 765.376 311.349 771.19 314.6L843.521 355.04Z",
    stroke: "url(#paint48_linear_6_177)",
    strokeWidth: 4
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.724638,
    d: "M846.945 353.162C854.449 356.891 859.343 364.35 859.732 372.652L863.54 453.862C863.85 460.481 861.255 466.897 856.425 471.456L781.39 542.27C777.087 546.331 771.363 548.583 765.412 548.555L671.094 548.118C663.296 548.082 656.027 544.146 651.767 537.653L610.073 474.103C605.813 467.61 605.137 459.436 608.276 452.37L646.235 366.905C648.63 361.512 653.036 357.252 658.534 355.013L754.41 315.965C760.582 313.452 767.56 313.715 773.542 316.688L846.945 353.162Z",
    stroke: "url(#paint49_linear_6_177)",
    strokeWidth: 4
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73913,
    d: "M850.206 351.696C857.823 355.031 863.056 362.159 863.906 370.361L872.194 450.313C872.879 456.921 870.636 463.489 866.045 468.314L796.369 541.551C792.259 545.87 786.61 548.431 780.616 548.692L687.96 552.727C680.201 553.065 672.779 549.517 668.204 543.284L623.58 482.49C619.005 476.257 617.89 468.173 620.612 460.974L653.121 374.996C655.224 369.434 659.431 364.908 664.851 362.374L756.75 319.413C762.804 316.582 769.809 316.5 775.946 319.187L850.206 351.696Z",
    stroke: "url(#paint50_linear_6_177)",
    strokeWidth: 4
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.753623,
    d: "M853.33 350.645C861.038 353.584 866.587 360.367 867.889 368.441L880.534 446.899C881.594 453.475 879.711 460.177 875.375 465.256L811.104 540.554C807.203 545.124 801.644 547.994 795.621 548.547L704.838 556.884C697.138 557.591 689.583 554.437 684.71 548.479L637.331 490.567C632.457 484.609 630.91 476.639 633.21 469.331L660.323 383.168C662.122 377.452 666.114 372.667 671.442 369.84L759.214 323.268C765.134 320.126 772.148 319.696 778.427 322.09L853.33 350.645Z",
    stroke: "url(#paint51_linear_6_177)",
    strokeWidth: 4
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.768116,
    d: "M856.344 350.012C864.121 352.554 869.964 358.977 871.705 366.899L888.571 443.635C890.005 450.159 888.49 456.975 884.424 462.295L825.583 539.295C821.904 544.109 816.452 547.286 810.413 548.134L721.699 560.593C714.077 561.664 706.413 558.907 701.258 553.24L651.302 498.323C646.147 492.656 644.178 484.823 646.051 477.432L667.842 391.404C669.326 385.548 673.088 380.513 678.309 377.395L761.824 327.52C767.595 324.073 774.601 323.295 781.007 325.388L856.344 350.012Z",
    stroke: "url(#paint52_linear_6_177)",
    strokeWidth: 4
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.782609,
    d: "M859.274 349.798C867.097 351.944 873.211 357.995 875.379 365.739L896.317 440.536C898.123 446.987 896.984 453.897 893.202 459.446L839.791 537.792C836.35 542.839 831.019 546.321 824.978 547.466L738.518 563.861C730.992 565.289 723.241 562.931 717.822 557.568L665.473 505.752C660.055 500.388 657.673 492.716 659.115 485.266L675.679 399.686C676.836 393.706 680.354 388.43 685.452 385.024L764.604 332.156C770.21 328.412 777.191 327.285 783.708 329.073L859.274 349.798Z",
    stroke: "url(#paint53_linear_6_177)",
    strokeWidth: 4
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.797101,
    d: "M862.145 350.001C869.995 351.753 876.354 357.421 878.935 364.965L903.786 437.616C905.961 443.972 905.205 450.956 901.719 456.718L853.716 536.061C850.527 541.331 845.334 545.114 839.303 546.559L755.268 566.695C747.856 568.471 740.039 566.515 734.376 561.468L679.821 512.846C674.157 507.799 671.375 500.308 672.385 492.826L683.832 407.997C684.654 401.909 687.912 396.401 692.874 392.712L767.575 337.164C773 333.13 779.938 331.656 786.552 333.132L862.145 350.001Z",
    stroke: "url(#paint54_linear_6_177)",
    strokeWidth: 4
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.811594,
    d: "M864.986 350.621C872.839 351.981 879.421 357.257 882.398 364.577L910.993 434.887C913.531 441.128 913.163 448.166 909.986 454.126L867.347 534.12C864.424 539.603 859.384 543.683 853.379 545.429L771.924 569.103C764.642 571.22 756.783 569.666 750.894 564.945L694.323 519.602C688.434 514.881 685.264 507.595 685.842 500.105L692.302 416.318C692.778 410.141 695.763 404.413 700.573 400.443L770.758 342.528C775.987 338.213 782.865 336.393 789.561 337.553L864.986 350.621Z",
    stroke: "url(#paint55_linear_6_177)",
    strokeWidth: 4
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.826087,
    d: "M867.819 351.651C875.656 352.625 882.435 357.501 885.793 364.577L917.951 432.36C920.848 438.466 920.871 445.536 918.016 451.678L880.674 531.987C878.031 537.671 873.16 542.043 867.193 544.09L788.46 571.097C781.326 573.544 773.446 572.39 767.35 568.007L708.958 526.014C702.863 521.631 699.319 514.569 699.466 507.097L701.085 424.633C701.208 418.383 703.904 412.447 708.549 408.203L774.173 348.233C779.192 343.647 785.992 341.484 792.754 342.325L867.819 351.651Z",
    stroke: "url(#paint56_linear_6_177)",
    strokeWidth: 4
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84058,
    d: "M870.671 353.089C878.471 353.681 885.424 358.15 889.143 364.963L924.676 430.048C927.924 435.998 928.342 443.078 925.819 449.385L893.687 529.681C891.337 535.553 886.652 540.213 880.737 542.561L804.853 572.687C797.882 575.455 790.003 574.7 783.721 570.662L723.703 532.082C717.421 528.044 713.519 521.226 713.238 513.797L710.178 432.925C709.939 426.622 712.335 420.49 716.798 415.977L777.837 354.262C782.631 349.415 789.337 346.914 796.149 347.431L870.671 353.089Z",
    stroke: "url(#paint57_linear_6_177)",
    strokeWidth: 4
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.855072,
    d: "M873.566 354.926C881.31 355.144 888.41 359.201 892.472 365.731L931.183 427.959C934.775 433.732 935.59 440.802 933.408 447.256L906.38 527.221C904.336 533.268 899.852 538.208 894.003 540.858L821.081 573.888C814.288 576.965 806.43 576.604 799.982 572.92L738.536 537.804C732.088 534.12 727.844 527.565 727.14 520.203L719.578 441.177C718.971 434.839 721.052 428.525 725.32 423.75L781.769 360.598C786.326 355.501 792.919 352.665 799.766 352.857L873.566 354.926Z",
    stroke: "url(#paint58_linear_6_177)",
    strokeWidth: 4
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.869565,
    d: "M876.527 357.156C884.196 357.005 891.42 360.649 895.805 366.878L937.489 426.102C941.414 431.679 942.627 438.716 940.797 445.299L918.744 524.627C917.019 530.834 912.752 536.048 906.983 538.997L837.119 574.713C830.519 578.088 822.705 578.117 816.112 574.792L753.435 543.181C746.842 539.856 742.273 533.581 741.151 526.312L729.278 449.373C728.297 443.021 730.051 436.538 734.11 431.508L785.985 367.221C790.29 361.886 796.754 358.721 803.62 358.586L876.527 357.156Z",
    stroke: "url(#paint59_linear_6_177)",
    strokeWidth: 4
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.884058,
    d: "M879.578 359.767C887.153 359.258 894.477 362.485 899.163 368.398L943.609 424.485C947.858 429.847 949.468 436.829 947.997 443.522L930.776 521.919C929.381 528.271 925.345 533.751 919.672 536.998L852.95 575.179C846.555 578.838 838.804 579.251 832.087 576.291L768.378 548.214C761.661 545.254 756.785 539.276 755.253 532.124L739.273 457.496C737.914 451.15 739.328 444.515 743.163 439.238L790.499 374.113C794.541 368.552 800.859 365.065 807.729 364.602L879.578 359.767Z",
    stroke: "url(#paint60_linear_6_177)",
    strokeWidth: 4
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.898551,
    d: "M882.74 362.751C890.204 361.891 897.602 364.702 902.568 370.285L949.56 423.114C954.121 428.242 956.126 435.146 955.022 441.93L942.469 519.116C941.415 525.598 937.627 531.334 932.062 534.876L868.55 575.301C862.375 579.232 854.707 580.022 847.886 577.43L783.344 552.907C776.524 550.315 771.359 544.65 769.427 537.638L749.556 465.532C747.815 459.213 748.878 452.441 752.476 446.927L795.326 381.252C799.092 375.48 805.248 371.677 812.105 370.887L882.74 362.751Z",
    stroke: "url(#paint61_linear_6_177)",
    strokeWidth: 4
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.913043,
    d: "M886.035 366.094C893.371 364.895 900.82 367.29 906.043 372.529L955.359 421.996C960.22 426.872 962.616 433.676 961.886 440.53L953.822 516.239C953.12 522.833 949.594 528.817 944.151 532.651L883.904 575.098C877.959 579.286 870.394 580.445 863.49 578.225L798.313 557.263C791.41 555.043 785.977 549.704 783.655 542.856L760.12 473.465C757.994 467.195 758.695 460.303 762.042 454.56L800.477 388.619C803.956 382.648 809.935 378.538 816.763 377.422L886.035 366.094Z",
    stroke: "url(#paint62_linear_6_177)",
    strokeWidth: 4
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.927536,
    d: "M889.483 369.784C896.676 368.256 904.152 370.239 909.609 375.122L961.022 421.134C966.169 425.74 968.952 432.422 968.601 439.326L964.832 513.308C964.491 519.997 961.242 526.217 955.935 530.341L898.993 574.588C893.29 579.02 885.845 580.539 878.881 578.692L813.264 561.289C806.299 559.442 800.619 554.442 797.919 547.781L770.956 481.28C768.443 475.082 768.772 468.087 771.855 462.126L805.963 396.191C809.146 390.037 814.932 385.628 821.715 384.187L889.483 369.784Z",
    stroke: "url(#paint63_linear_6_177)",
    strokeWidth: 4
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.942029,
    d: "M893.105 373.807C900.137 371.962 907.618 373.535 913.284 378.053L966.567 420.533C971.985 424.852 975.15 431.389 975.18 438.322L975.498 510.343C975.528 517.108 972.57 523.554 967.413 527.963L913.802 573.791C908.349 578.452 901.044 580.321 894.039 578.847L828.176 564.99C821.171 563.516 815.265 558.868 812.2 552.415L782.055 488.965C779.155 482.861 779.102 475.781 781.909 469.613L811.794 403.947C814.671 397.625 820.249 392.927 826.972 391.163L893.105 373.807Z",
    stroke: "url(#paint64_linear_6_177)",
    strokeWidth: 4
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.956522,
    d: "M896.917 378.148C903.776 375.997 911.238 377.167 917.09 381.31L972.011 420.194C977.683 424.21 981.222 430.58 981.638 437.522L985.822 507.364C986.23 514.187 983.577 520.847 978.583 525.536L928.315 572.728C923.123 577.602 915.974 579.81 908.949 578.709L843.032 568.375C836.008 567.274 829.898 562.987 826.482 556.763L793.407 496.505C790.121 490.518 789.677 483.373 792.196 477.008L817.979 411.864C820.541 405.39 825.896 400.414 832.544 398.329L896.917 378.148Z",
    stroke: "url(#paint65_linear_6_177)",
    strokeWidth: 4
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.971014,
    d: "M900.937 382.789C907.609 380.347 915.029 381.119 921.042 384.881L977.369 420.119C983.279 423.816 987.185 429.999 987.988 436.926L995.803 504.391C996.598 511.252 994.263 518.114 989.445 523.078L942.519 571.419C937.596 576.491 930.619 579.026 923.596 578.296L857.813 571.452C850.79 570.721 844.498 566.806 840.748 560.832L805.001 503.889C801.331 498.042 800.488 490.85 802.707 484.302L824.523 419.92C826.763 413.309 831.882 408.066 838.439 405.665L900.937 382.789Z",
    stroke: "url(#paint66_linear_6_177)",
    strokeWidth: 4
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.985507,
    d: "M905.181 387.714C911.654 384.994 919.01 385.376 925.16 388.751L982.66 420.309C988.789 423.673 993.052 429.646 994.242 436.538L1005.45 501.443C1006.63 508.323 1004.63 515.373 1000 520.606L956.403 569.887C951.755 575.141 944.967 577.991 937.965 577.627L872.5 574.231C865.499 573.868 859.049 570.332 854.981 564.626L816.827 511.104C812.775 505.421 811.528 498.202 813.435 491.483L831.432 428.092C833.343 421.361 838.212 415.862 844.664 413.15L905.181 387.714Z",
    stroke: "url(#paint67_linear_6_177)",
    strokeWidth: 4
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M909.665 392.906C915.925 389.922 923.198 389.922 929.458 392.906L987.898 420.763C994.23 423.781 998.838 429.522 1000.41 436.357L1014.75 498.541C1016.34 505.418 1014.68 512.643 1010.25 518.139L969.956 568.154C965.59 573.573 959.005 576.724 952.045 576.724H887.078C880.119 576.724 873.534 573.573 869.168 568.154L828.872 518.139C824.444 512.643 822.785 505.418 824.371 498.541L838.71 436.357C840.286 429.522 844.894 423.781 851.225 420.763L909.665 392.906Z",
    stroke: "url(#paint68_linear_6_177)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_177",
    x1: 169.515,
    y1: 536.399,
    x2: 382.084,
    y2: 54.0528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_177",
    x1: 192.215,
    y1: 542.076,
    x2: 377.714,
    y2: 53.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_177",
    x1: 214.944,
    y1: 547.026,
    x2: 373.368,
    y2: 54.4384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_177",
    x1: 237.662,
    y1: 551.255,
    x2: 369.082,
    y2: 55.7467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_177",
    x1: 260.327,
    y1: 554.769,
    x2: 364.89,
    y2: 57.7797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_177",
    x1: 282.901,
    y1: 557.578,
    x2: 360.826,
    y2: 60.5217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_177",
    x1: 305.347,
    y1: 559.694,
    x2: 356.921,
    y2: 63.9566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_177",
    x1: 327.627,
    y1: 561.132,
    x2: 353.205,
    y2: 68.0673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_177",
    x1: 349.706,
    y1: 561.905,
    x2: 349.706,
    y2: 72.8362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_177",
    x1: 371.547,
    y1: 562.033,
    x2: 346.45,
    y2: 78.2455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6_177",
    x1: 393.118,
    y1: 561.534,
    x2: 343.467,
    y2: 84.2767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6_177",
    x1: 414.387,
    y1: 560.429,
    x2: 340.779,
    y2: 90.9107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6_177",
    x1: 435.323,
    y1: 558.741,
    x2: 338.412,
    y2: 98.1285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6_177",
    x1: 455.897,
    y1: 556.494,
    x2: 336.391,
    y2: 105.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6_177",
    x1: 476.081,
    y1: 553.713,
    x2: 334.738,
    y2: 114.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6_177",
    x1: 495.85,
    y1: 550.425,
    x2: 333.477,
    y2: 123.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6_177",
    x1: 515.18,
    y1: 546.658,
    x2: 332.629,
    y2: 132.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6_177",
    x1: 534.048,
    y1: 542.441,
    x2: 332.216,
    y2: 142.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6_177",
    x1: 552.434,
    y1: 537.803,
    x2: 332.259,
    y2: 152.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6_177",
    x1: 570.32,
    y1: 532.777,
    x2: 332.78,
    y2: 163.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6_177",
    x1: 587.689,
    y1: 527.393,
    x2: 333.797,
    y2: 174.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6_177",
    x1: 604.527,
    y1: 521.684,
    x2: 335.329,
    y2: 185.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6_177",
    x1: 620.82,
    y1: 515.682,
    x2: 337.396,
    y2: 197.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6_177",
    x1: 636.559,
    y1: 509.42,
    x2: 340.013,
    y2: 209.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6_177",
    x1: 651.735,
    y1: 502.933,
    x2: 343.197,
    y2: 222.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6_177",
    x1: 666.342,
    y1: 496.253,
    x2: 346.963,
    y2: 234.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6_177",
    x1: 680.374,
    y1: 489.414,
    x2: 351.321,
    y2: 247.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6_177",
    x1: 693.829,
    y1: 482.45,
    x2: 356.284,
    y2: 260.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6_177",
    x1: 706.707,
    y1: 475.394,
    x2: 361.861,
    y2: 274.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6_177",
    x1: 719.008,
    y1: 468.279,
    x2: 368.057,
    y2: 287.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6_177",
    x1: 730.736,
    y1: 461.138,
    x2: 374.879,
    y2: 301.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6_177",
    x1: 741.897,
    y1: 454.004,
    x2: 382.327,
    y2: 314.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6_177",
    x1: 752.496,
    y1: 446.907,
    x2: 390.4,
    y2: 328.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6_177",
    x1: 762.543,
    y1: 439.879,
    x2: 399.096,
    y2: 341.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6_177",
    x1: 772.048,
    y1: 432.949,
    x2: 408.407,
    y2: 354.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6_177",
    x1: 781.023,
    y1: 426.148,
    x2: 418.325,
    y2: 368.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6_177",
    x1: 789.482,
    y1: 419.503,
    x2: 428.838,
    y2: 381.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6_177",
    x1: 797.439,
    y1: 413.041,
    x2: 439.93,
    y2: 394.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6_177",
    x1: 804.912,
    y1: 406.789,
    x2: 451.584,
    y2: 406.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6_177",
    x1: 811.918,
    y1: 400.771,
    x2: 463.78,
    y2: 419.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6_177",
    x1: 818.476,
    y1: 395.011,
    x2: 476.494,
    y2: 431.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6_177",
    x1: 824.608,
    y1: 389.531,
    x2: 489.703,
    y2: 443.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6_177",
    x1: 830.334,
    y1: 384.352,
    x2: 503.378,
    y2: 454.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6_177",
    x1: 835.676,
    y1: 379.493,
    x2: 517.49,
    y2: 465.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6_177",
    x1: 840.66,
    y1: 374.972,
    x2: 532.009,
    y2: 476.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6_177",
    x1: 845.308,
    y1: 370.805,
    x2: 546.904,
    y2: 486.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6_177",
    x1: 849.645,
    y1: 367.007,
    x2: 562.139,
    y2: 496.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6_177",
    x1: 853.697,
    y1: 363.59,
    x2: 577.683,
    y2: 505.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6_177",
    x1: 857.491,
    y1: 360.568,
    x2: 593.5,
    y2: 514.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6_177",
    x1: 861.053,
    y1: 357.948,
    x2: 609.557,
    y2: 522.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6_177",
    x1: 864.409,
    y1: 355.74,
    x2: 625.818,
    y2: 530.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6_177",
    x1: 867.588,
    y1: 353.95,
    x2: 642.25,
    y2: 538.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6_177",
    x1: 870.615,
    y1: 352.582,
    x2: 658.819,
    y2: 545.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6_177",
    x1: 873.518,
    y1: 351.64,
    x2: 675.492,
    y2: 551.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6_177",
    x1: 876.324,
    y1: 351.125,
    x2: 692.238,
    y2: 557.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_6_177",
    x1: 879.06,
    y1: 351.038,
    x2: 709.025,
    y2: 563.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_6_177",
    x1: 881.752,
    y1: 351.376,
    x2: 725.825,
    y2: 568.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_6_177",
    x1: 884.427,
    y1: 352.136,
    x2: 742.609,
    y2: 572.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_6_177",
    x1: 887.111,
    y1: 353.313,
    x2: 759.35,
    y2: 576.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_6_177",
    x1: 889.829,
    y1: 354.901,
    x2: 776.023,
    y2: 580.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_6_177",
    x1: 892.604,
    y1: 356.892,
    x2: 792.605,
    y2: 583.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_6_177",
    x1: 895.462,
    y1: 359.278,
    x2: 809.072,
    y2: 586.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_6_177",
    x1: 898.424,
    y1: 362.047,
    x2: 825.404,
    y2: 589.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_6_177",
    x1: 901.513,
    y1: 365.187,
    x2: 841.582,
    y2: 591.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_6_177",
    x1: 904.75,
    y1: 368.687,
    x2: 857.586,
    y2: 592.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_6_177",
    x1: 908.155,
    y1: 372.531,
    x2: 873.402,
    y2: 594.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_6_177",
    x1: 911.747,
    y1: 376.704,
    x2: 889.012,
    y2: 595.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_6_177",
    x1: 915.544,
    y1: 381.19,
    x2: 904.403,
    y2: 595.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_6_177",
    x1: 919.562,
    y1: 385.973,
    x2: 919.562,
    y2: 596.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.f784291a702466317163f4e1f44afdd7.svg";
export { ForwardRef as ReactComponent };